"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  zIndex: {
    sidebar: 9,
    elementSelected: 1,
    elementAdd: 2,
    elementDelete: 1
  }
};
exports["default"] = _default;